module.exports = __webpack_public_path__ + "img/phone_scanning.993d0c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/phone_scanning.png
// module id = ou1l
// module chunks = 1